import { Typography } from '@mui/material';
import { useAppSelector } from 'app/hooks';

import { disciplinaInfoSelector } from '#modules/disciplinas/redux/disciplinaInfoSlice';

import { BoxInfo } from './styles';

export function PlanoEnsinoInterdisciplinaridade() {
  const disciplina = useAppSelector(disciplinaInfoSelector.disciplina);

  if (disciplina == null) return <></>;

  return (
    <BoxInfo id="descricao">
      <header>
        <Typography>DESCRIÇÃO DA INTERDISCIPLINARIDADE</Typography>
      </header>

      <div>
        <Typography>{disciplina.interdisciplinaridade}</Typography>
      </div>
    </BoxInfo>
  );
}
